export const object2Search = (object: Record<string, any>): string => {
  return Object.entries(object).reduce(
    (acc: string, [key, value]: [string, any], index: number) => {
      return acc + `${index ? '&' : ''}${key}=${value}`;
    },
    '?',
  );
};
